<script setup lang="ts">
import LockedOption from '@/components/LockedOption.vue'
import type { FacetOption } from '@/browse/browse_state'
import { facetOptionStateClasses } from '@/browse/facet_option_classes'

defineProps<{ options: FacetOption[], labelledBy: string }>()

const emit = defineEmits<{ toggle: [value: string] }>()

const ADULT_TRANSITION = 'Adult-Transition'

const TILE_CLASSES = 'w-full rounded-lg px-2 py-1 text-center text-text-md leading-5'
</script>

<template>
  <div role="group" :aria-labelledby="labelledBy">
    <ol :aria-labelledby="labelledBy" class="grid grid-cols-[repeat(auto-fit,2rem)] justify-center gap-1">
      <li v-for="option in options" :key="option.value" :class="{ 'col-span-2': option.value === ADULT_TRANSITION }">
        <LockedOption v-if="option.isLocked" :label="option.label" class="cursor-not-allowed flex-col" :class="TILE_CLASSES" />
        <label
          v-else
          class="flex flex-col items-center"
          :class="[TILE_CLASSES, facetOptionStateClasses(option)]"
        >
          <span class="flex h-5 items-center">
            <input
              type="checkbox"
              class="accent-blue-400"
              :class="{ invisible: !option.isEnabled }"
              :checked="option.isSelected"
              :disabled="!option.isEnabled"
              @change="emit('toggle', option.value)"
            >
          </span>
          {{ option.label }}
        </label>
      </li>
    </ol>
  </div>
</template>
